"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobile = exports.userAgent = void 0;
var ua_parser_js_1 = require("ua-parser-js");
var parser = new ua_parser_js_1.UAParser(window.navigator.userAgent);
var type = parser.getDevice().type;
exports.userAgent = parser.getResult();
exports.isMobile = type === 'mobile' || type === 'tablet';
